import { render, staticRenderFns } from "./ZT_loss_attachment-modal.vue?vue&type=template&id=aadd87a0&scoped=true"
import script from "./ZT_loss_attachment-modal.vue?vue&type=script&lang=js"
export * from "./ZT_loss_attachment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadd87a0",
  null
  
)

export default component.exports